// extracted by mini-css-extract-plugin
export default {"wrapper":"Table_wrapper__lDYjz","inner":"Table_inner__RcQ+e","table-action":"Table_table-action__s3MYI"};